export default __webpack_public_path__ + "./images/ya.64de80bd.svg";